/**
 * Creates html element from html string
 * @param {string} html
 * @return {HTMLElement}
 */
export function createElement(html) {
    const el = document.createElement("div");
    el.innerHTML = html;

    return el.firstElementChild;
}
